
<div class="logo">
    @if (brandLogoSvg) {
         <mat-icon class="logo-icon-svg" svgIcon="brand_square"></mat-icon>
    }
    @else {
        <img src="assets/{{ brand }}/images/logos/brand-square.png" alt="" />
    }
</div>

